import { HttpErrorResponse } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ICategoriaProduto } from '@app/modules/categoria-produtos/model';
import { CategoriaProdutoService } from '@app/modules/categoria-produtos/services';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { ScreenService } from '@app/shared/services';
import { Dialog } from 'primeng/dialog';
import {
  CustomValidators,
  ErroMessages,
  IErroMessages,
  TokenService
} from 'viggo-sistemas-core-web';
import { Utils } from '../../../../shared/helpers/utils';

@Component({
  selector: 'app-fast-categoria-produto',
  templateUrl: './fast-categoria-produto.component.html',
  styleUrls: ['./fast-categoria-produto.component.scss'],
  providers: [CategoriaProdutoService]
})
export class FastCategoriaProdutoComponent implements OnInit, AfterViewInit {
  @ViewChild('fastCategoriaProd') fastCategoriaProd: Dialog;
  public form: UntypedFormGroup;

  loading = false;

  loadingCodigo = true;

  displayMessages = {
    codigo: {
      required: 'O código é obrigatório',
      repeated: 'Este código já está em uso.',
      maxlength: 'O código deve conter no máximo 6 caracteres.'
    },
    descricao: {
      duplicate: 'Já existe uma categoria com essa descrição!',
      required: 'A descrição é obrigatória',
      maxlength: 'Não pode ter mais de 60 caracteres',
      isEmptyValue: 'Valor inválido: remova os espaços em branco!'
    }
  };

  constructor(
    public screenService: ScreenService,
    public dialogRef: MatDialogRef<FastCategoriaProdutoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ICategoriaProduto,
    protected fb: UntypedFormBuilder,
    public entityService: CategoriaProdutoService,
    public tokenService: TokenService,
    public matSnackBar: MatSnackBar,
    public matDialog: MatDialog,
    public router: Router
  ) {}

  ngAfterViewInit(): void {
    if (this.screenService.detectDeviceInfo().isMobile)
      this.fastCategoriaProd.maximize();
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      descricao: [
        null,
        [
          Validators.required,
          Validators.maxLength(60),
          CustomValidators.isEmptyValue()
        ]
      ]
    });
  }

  /**
   * Faz a pesquisa no backend do grupo apartir do nome evitando
   * trazer os grupos que são filho
   * @param texto texto a ser buscado
   */
  public searchFn = (
    texto: string,
    include: string[],
    order_by: string[],
    page: number,
    page_size: number
  ) =>
    this.entityService.getEntitiesByParams(
      {
        where: {
          descricao: `${texto}%`,
          domain_id: this.tokenService.getDomain().id
        },
        pagination: {
          page: page,
          page_size: page_size
        }
      },
      undefined,
      true
      // `nome=${texto}%&domain_id=${this.domainId}&parent_id=null`
    );

  public submit(): void {
    if (!this.form.valid) return;

    this.loading = true;
    const { ...rest } = this.form.value;
    var entity = { domain_id: this.tokenService.getDomain().id, ...rest };

    entity = Utils.trimAttributes(entity);
    this.entityService.insert(entity).subscribe(
      categoria => {
        if (categoria) {
          this.matSnackBar.open(
            `Categoria de produto cadastrada com sucesso.`,
            'X',
            {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            }
          );
          this.dialogRef.close(categoria);
        }
      },
      (err: HttpErrorResponse) => {
        this.displayError(err);
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  actionFnCheckEntityExist(control: AbstractControl) {
    Utils.checkIfValueExist(
      control,
      this.entityService,
      'descricao',
      this.tokenService.getDomain().id
    );
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.matDialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'warning',
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.showMessageObject(err.error);
    // errorMsg.checkError();
  }
}
